import { isValid, parse, startOfDay } from 'date-fns'
import { z } from 'zod'

export const updateContractClosingDateSchema = z.object({
  closing_date: z
    .string({ message: 'Data obrigatória' })
    .regex(/^\d{2}\/\d{2}\/\d{4}$/, {
      message: 'Data inválida. Use o formato DD/MM/YYYY',
    })
    .refine(
      (value) => {
        const parsedDate = parse(value, 'dd/MM/yyyy', new Date())
        return isValid(parsedDate)
      },
      { message: 'Data inválida' },
    )
    .refine(
      (value) => {
        const parsedDate = startOfDay(parse(value, 'dd/MM/yyyy', new Date()))
        const today = startOfDay(new Date())
        return parsedDate >= today
      },
      { message: 'A data de fechamento deve ser hoje ou uma data futura.' },
    ),
})

export type UpdateContractClosingDateSchema = z.infer<typeof updateContractClosingDateSchema>
